import { TFunction } from 'i18next';

export const formatRangeValue = (
  { from, to }: { from: string | null; to: string | null },
  measurementUnit: string,
  t: TFunction
): string | null => {
  if (from && to) {
    return `${from} - ${to} ${measurementUnit}`;
  }

  if (from) {
    return `${t('common.from')} ${from} ${measurementUnit}`;
  }

  if (to) {
    return `${t('common.to')} ${to} ${measurementUnit}`;
  }

  return null;
};

export const formatBooleanValue = (
  value: boolean | undefined,
  t: TFunction
) => {
  if (typeof value !== 'boolean') return null;

  return value ? t('common.yes') : t('common.no');
};
